import { render } from "./work-order-receiving-detail.vue?vue&type=template&id=f3b60d4c"
import script from "./work-order-receiving-detail.vue?vue&type=script&lang=js"
export * from "./work-order-receiving-detail.vue?vue&type=script&lang=js"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__